export enum OptionalScope {
    Attributes = "Attributes",
    Photo = "Photo",
    Score = "Score",
    GeoJson = "GeoJson",
    Description = "Description",
    PlannedTrajectory = "PlannedTrajectory",
    Stats = "Stats",
    PhotoLabels = "PhotoLabels",
    CodingSuggestions = "CodingSuggestions",
    SafetyTreatmentModel = "SafetyTreatmentModel",
    ScoreImpact = "ScoreImpact"
  }
  